import { ActionType, getType } from 'typesafe-actions'

import * as actions from './actions'
import { IInstallationsState, createInitialInstallationsState } from './types'
import { IInstallation } from '../../types/installation'
import { IEntityHashMap } from 'flux-entities'

type TAction = ActionType<typeof actions>

const initialInstallationsState = createInitialInstallationsState()

const installationsReducer = (state = initialInstallationsState, action: TAction): IInstallationsState => {
  switch (action.type) {
    case getType(actions.installationsError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.installationsRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.installationsSuccess): {
      const all: {[id: number]: IInstallation} = {}
      const ids: number[] = []

      for (const installation of action.payload) {
        if (!all[installation.id]) {
          ids.push(installation.id)
          all[installation.id] = installation
        }
      }

      return {
        all,
        ids,
        touched: true,
        loading: false,
        errors: []
      }
    }

    case getType(actions.installationCreateError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.installationCreateRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.installationCreateSuccess): {
      return {
        ids: Array.from(new Set([...state.ids, action.payload.id])),
        all: {
          ...state.all,
          [action.payload.id]: action.payload,
        },
        touched: true,
        loading: false,
        errors: []
      }
    }

    case getType(actions.installationDeleteError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.installationDeleteRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.installationDeleteSuccess): {
      const ids = state.ids.filter(x => x !== action.payload.id)
      const updatedState: IEntityHashMap<IInstallation> = { ...state.all }
      delete updatedState[action.payload.id]

      return {
        ids,
        all: updatedState,
        touched: true,
        loading: false,
        errors: []
      }
    }

    case getType(actions.installationUpdateError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.installationUpdateRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.installationUpdateSuccess): {
      return {
        ...state,
        all: {
          ...state.all,
          [action.payload.id]: action.payload,
        },
        touched: true,
        loading: false,
        errors: []
      }
    }
  }

  return state
}

export {
  installationsReducer,
  initialInstallationsState
}
